<template>
  <el-form-item v-bind="itemBinds" class="master-table" label-width="0">
    <!-- header -->
    <div class="master-table-header">
      <FormHeader>{{ headLabel }}</FormHeader>
    </div>

    <vxe-table
      ref="dataTable"
      :data="value.scoreResult"
      border
      resizable
      show-overflow
      show-header-overflow
      show-footer-overflow
      style="width: 100%"
      :max-height="tableHeight"
    >
      <vxe-column fixed="left" type="seq" title="#" width="60" align="center" />
      <template v-if="value.examineType === 'score'">
        <vxe-column
          v-for="quota of columns"
          :key="quota.prop"
          :title="quota.label"
          :field="quota.prop"
          align="center"
        />
      </template>
      <template v-else>
        <vxe-column
          v-for="quota of columnsRank"
          :key="quota.prop"
          :title="quota.label"
          :field="quota.prop"
          align="center"
        />
      </template>
      <template #empty>
        <Empty />
      </template>
    </vxe-table>
  </el-form-item>
</template>

<script>
import FormHeader from '@/components/form/form-header/form-header.vue'
import Empty from '../small/empty.vue'
export default {
  name: 'ScoreResult',
  components: {
    FormHeader,
    Empty
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    itemBinds: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      columns: [
        { prop: 'markStart', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.markStart') },
        { prop: 'markEnd', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.markEnd') },
        { prop: 'examineLevel', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.examineLevel') },
        { prop: 'levelRemarks', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.levelRemarks') },
        { prop: 'qualifiedStatusName', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.qualifiedStatus') },
        { prop: 'performanceStrategyName', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.performanceStrategy') }
      ],
      columnsRank: [
        { prop: 'rankStart', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.rankStart') },
        { prop: 'rankEnd', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.rankEnd') },
        { prop: 'examineLevel', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.examineLevel') },
        { prop: 'levelRemarks', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.levelRemarks') },
        { prop: 'qualifiedStatusName', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.qualifiedStatus') },
        { prop: 'performanceStrategyName', label: this.$t('performanceAppraisal.performanceAppraisal.scoreResult.performanceStrategy') }
      ],
      scoreResult: [],
      tableHeight: '350px'
    }
  },
  computed: {
    headLabel() {
      return this.value.examineType === 'score'
        ? this.$t('performanceAppraisal.performanceAppraisal.formTitle.processResult[0]')
        : this.$t('performanceAppraisal.performanceAppraisal.formTitle.processResult[1]')
    }
  }
}
</script>

<style scoped>

</style>
